import { useRef, useEffect } from "react";

const useIntersectionObserver = (callback, options) => {
    const targetRef = useRef()
  
    useEffect(() => {
        const observer = new IntersectionObserver(callback, options)
        if (targetRef.current) observer.observe(targetRef.current)

        return () => {
            if (targetRef.current) observer.unobserve(targetRef.current)
        };
    }, []);
  
    return targetRef
};

export default useIntersectionObserver